import { ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ICatalogue } from "../../../apis/useGetCatalogueData/types";
import { LANGUAGE } from "../../../i18n";

interface IProps {
	item: ICatalogue | null;
}

const RemoveCartItemMessage = ({ item }: IProps): ReactElement => {
	const { t, i18n } = useTranslation();

	const msg = useMemo(() => {
		const title = (i18n.language === LANGUAGE.CN ? item?.title_cn : item?.title) ?? "";

		return t("cartPage.confirmRemove").split("{item}").join(title);
	}, [t, i18n]);

	return <div className="PopupDialogContent">{msg}</div>;
};

export default RemoveCartItemMessage;
